import { useAuthStore } from '@/stores/authStore';

/**
 * Hook for authentication state and methods.
 *
 * Session initialization and the onAuthStateChange subscription live in
 * initAuth() (authStore), called once from main.tsx — NOT in a component
 * effect. A component-owned subscription dies with the first component that
 * mounted it, after which session expiry/revocation would go undetected.
 */
export function useAuth() {
  const { user, profile, loading, signIn, signOut, updateProfile } = useAuthStore();

  return {
    user,
    profile,
    loading,
    isAuthenticated: !!user,
    signIn,
    signOut,
    updateProfile,
  };
}
